import { Footer } from "antd/es/layout/layout";
import styled from "styled-components";

export const StyledFooter = styled(Footer)`
  padding: 0.25rem 0;
  height: 1.5rem !important;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  line-height: 1.5rem;
  cursor: pointer;

  background-color: ${({ theme }) => theme.colors.white};
`;

export const StyledImg = styled.img`
  height: 100%;
  padding-right: 0.375rem;
`;

export const StyledParagraph = styled.p`
  font-size: 0.75rem;
  color: default;

  font-weight: 500;
`;
